import taskAPI from '@/apis/eTask/taskAPI';
export default {
  namespaced: true,
  state: () => ({
    /**
     * Danh sách mức độ ưu tiên
     */
    priorityOptions: [],

    /**
     * Danh sách loại việc
     */
    taskTypeOptions: [],

    /**
     * Danh sách người dùng đc người hiện tại ủy quyền
     */
    authorizedUsers: [],

    /**
     * Danh sách công việc cha
     */
    taskList: [],
    /**
     * Số lượng danh sách công việc
     */
    taskListCount: 0,

    /**
     * Số lượng công việc hiển thị tại left menu
     */
    taskCount: {
      /**
       * Tôi cần thực hiện
       */
      CountNeedToDoTasks: 0,

      /**
       * Tôi cần phê duyệt
       */
      CountNeedToApproveTasks: 0,

      /**
       * Đề xuất gia hạn hoàn thành
       */
      CountNeedToApproveUpdateDeadline: 0,
    }
  }),
  getters: {
    /**
     * Format lại số lượng công việc
     * @param {*} state
     * @returns Số lượng công việc sau khi format
     * @author: BMThang(07/02/2023)
     */
    taskCount(state) {
      return {
        CountNeedToDoTasks: state.taskCount.CountNeedToDoTasks > 99 ? '99+' : state.taskCount.CountNeedToDoTasks,
        CountNeedToApproveTasks: state.taskCount.CountNeedToApproveTasks + state.taskCount.CountNeedToApproveUpdateDeadline > 99 ? '99+' :
          state.taskCount.CountNeedToApproveTasks + state.taskCount.CountNeedToApproveUpdateDeadline,
      }
    }
  },
  actions: {
    /**
     * Lấy danh sách công việc (ko biết có dùng ko)
     * @param {*} context
     * @param {*} param param paging
     */
    async getTaskList(context, param) {
      const tempData = taskAPI.getTaskListPaging(param);
      let data = {
        Data: [],
        Total: 0,
      };
      try {
        data = JSON.parse(tempData);
      } catch (e) {
        console.log(e);
      } finally {
        context.commit('setTaskList', data);
      }
    },

    /**
     * Lấy số lượng công việc hiển thị trên left menu
     * @param {*} context
     * @author: BMThang(07/02/2023)
     */
    async getTaskCount(context) {
      try {
        const taskCount = await taskAPI.getTaskCount();
        context.commit('setTaskCount', taskCount);
      } catch (error) {
        context.commit('setTaskCount', {
          CountNeedToDoTasks: 0,
          CountNeedToApproveTasks: 0,
        });
        console.error(error);
      }
    }
  },
  mutations: {
    /**
     * Set priorityOptions
     * @param {*} state
     * @param {array} priorityOptions priorityOptions
     * @author: BMThang(29/12/2022)
     */
    setPriorityOptions: (state, priorityOptions) => {
      state.priorityOptions = priorityOptions;
    },
    /**
     * Lưu lại danh sách công việc
     */
    setTaskList: (state, data) => {
      state.taskList = data?.Data;
      state.taskListCount = data?.Total;
    },
    /**
     * Set taskTypeOptions
     * @param {*} state
     * @param {array} taskTypeOptions taskTypeOptions
     * @author: BMThang(29/12/2022)
     */
    setTaskTypeOptions: (state, taskTypeOptions) => {
      state.taskTypeOptions = taskTypeOptions;
    },

    /**
     * Set authorizedUsers
     * @param {*} state
     * @param {array} authorizedUsers authorizedUsers
     * @author: BMThang(29/12/2022)
     */
    setAuthorizedUsers: (state, authorizedUsers) => {
      state.authorizedUsers = authorizedUsers;
    },

    /**
     * Xét số lượng công việc hiển thị trên left menu
     * @param {*} state
     * @param {object} taskCount taskCount object
     * @author: BMThang(07/02/2023)
     */
    setTaskCount: (state, taskCount) => {
      state.taskCount = taskCount;
    },
  },
};
